import React, { useState, useEffect, useCallback } from 'react';
import AresNavBar from './../Layout/NavBar/NavBar';
import { useParams } from 'react-router-dom'
import SideBar from '../Layout/SideBar/SideBar';
import moment from 'moment';
import swal from 'sweetalert';

import './index.css'
import { Button, Col, Form, InputGroup, Row, Spinner, Tab, Tabs } from 'react-bootstrap';
import client from "../../services/Api";
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import DeviceChart from '../Travel/DeviceCharts';
import { downloadReport } from '../../utils/Report'
import Switch from "react-switch";
import DeviceLog from '../DeviceLog';
import DeviceNotification from '../DeviceNotification';

function DeviceHistory({ location, history, params }) {

  const [loading, setLoading] = useState(true)
  const [beacons, setBeacons] = useState([])
  const [deviceHistory, setDeviceHistory] = useState([])
  const [tableData, setTableData] = useState(null)
  const [device, setDevice] = useState(null)
  const [utcDate, setUtcDate] = useState(false);
  const initDateDefault = moment().subtract(2, 'd').toISOString().substr(0, 16);
  const endDateDefault = new Date().toISOString().substr(0, 16);

  const [dateInit, setDateInit] = useState(initDateDefault);
  const [dateEnd, setDateEnd] = useState(endDateDefault);

  const [dateInitUtc, setDateInitUtc] = useState(null);
  const [dateEndUtc, setDateEndUtc] = useState(null)

  const [minTemp, setMinTemp] = useState(null)
  const [maxTemp, setMaxTemp] = useState(null)

  const [minHum, setMinHum] = useState(null)
  const [maxHum, setMaxHum] = useState(null)


  const [filters, setFilters] = useState({ lastTwoDays: true, dateInit: initDateDefault, dateEnd: endDateDefault });
  const { mac, id } = useParams();
  const [key, setKey] = useState('data');

  const tabController = useCallback((key) => {
    console.log('chave: ', key)
    setKey(key)
  }, [])

  //datatable config
  const columns = [
    {
      name: 'Data/Hora',
      format: row => moment.utc(row.createdAt).local().format('DD/MM/YYYY HH:mm:ss'),
      selector: 'created_at',
      sortable: true,
      width: '20%',
    },
    {
      name: 'Data/Hora (UTC)',
      format: row => moment.utc(row.createdAt).format('DD/MM/YYYY HH:mm:ss'),
      selector: 'created_at',
      sortable: true,
      width: '20%',
    },
    {
      name: 'Temperatura',
      format: row => row.temperature.toFixed(2) + '°C',
      selector: 'temperature',
      sortable: false,
      width: '20%',
    },
    {
      name: 'Umidade',
      format: row => row.humidity.toFixed(2) + '%',
      selector: 'humidity',
      sortable: false,
      width: '20%',
    },
  ];

  useEffect(() => {
    setLoading(true)
    async function makeDevice() {
      await getDevice();
    }
    makeDevice()
  }, []);

  async function init() {
    const response = await getBeaconHistory();
    if (response !== null) {
      const data = response.data;

      setBeacons(data);
      setTableData({
        data,
        columns
      })
    }
    setLoading(false);
  }

  useEffect(() => {
    getBeaconHistory();
  }, [filters]);

  async function applyFilters() {
    const filterData = await {
      minTemp: minTemp,
      maxTemp: maxTemp,
      minHum: minHum,
      maxHum: maxHum,
      dateInit: dateInit,
      dateEnd: dateEnd,
      dateInitUtc: dateInitUtc,
      dateEndUtc: dateEndUtc,
      isUtc: utcDate
    }
    await setFilters(filterData);

  }

  async function getDevice() {
    try {
      const response = await client.get(`/api/show-beacon-device/${id}`);
      setDevice(response.data);
      return response;
    } catch (e) {
      console.log(e);
    }
    return null;
  }

  function serialize(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }

  async function downloadExcel() {
    try {
      setLoading(true)
      const response = await client.get(`/api/beacon-device/history/mac/${mac}/excel`, { params: filters });
      await downloadReport(`/api/report/files/${response.data._id}`, response.data.file);
      setLoading(false);
      return response;
    } catch (e) {
      setLoading(false);
      const message = e.response ? e.response.data.error : e.message;
      swal("Erro!", message, "error")
    }
    return null;
  }

  async function downloadPDF() {
    try {
      setLoading(true)
      const response = await client.get(`/api/beacon-device/history/mac/${mac}/pdf`, { params: filters });
      await downloadReport(`/api/report/files/${response.data._id}`, response.data.file);
      setLoading(false)
      return response;
    } catch (e) {
      setLoading(false);
      const message = e.response ? e.response.data.error : e.message;
      swal("Erro!", message, "error")
    }
    return null;
  }

  async function getBeaconHistory() {
    try {
      setLoading(true);
      const response = await client.get(`/api/beacon-device/history/mac/${mac}`, { params: filters });
      setDeviceHistory(response.data);
      if (response !== null) {
        const data = response.data;
        setBeacons(data);
        setTableData({
          data,
          columns
        })
      }
      setLoading(false);
      return response;
    } catch (e) {
      console.log(e);
    }
    return null;
  }

  function renderLoading() {
    return (
      <div className="center-page">
        <Spinner animation="border" />
      </div>
    )
  }


  const customStyles = {
    rows: {
      style: {
        '&:hover': {
          backgroundColor: '#03989E',
          color: 'white',
          transition: '.2s'
        },
      }
    },
  };

  function showFilters() {
    return (
      <>
        {key == 'data' ? exportButtons() : null}
        <Form>
          <Row>
            <Col md={3}>
              <label className="SearchLabel">Temperatura Min </label>
              <InputGroup>
                <Form.Control
                  value={minTemp != null ? minTemp : ''}
                  onChange={(e) => setMinTemp(e.target.value)}
                  placeholder="Temperatura mínima"
                  type="number"
                  className="form-input"
                />
              </InputGroup>
            </Col>

            <Col md={3}>
              <label className="SearchLabel">Temperatura Max</label>
              <InputGroup>
                <Form.Control
                  value={maxTemp != null ? maxTemp : ''}
                  onChange={(e) => setMaxTemp(e.target.value)}
                  placeholder="Temperatura máxima"
                  type="number"
                  className="form-input"

                />
              </InputGroup>
            </Col>


            <Col md={3}>
              <label className="SearchLabel">Umidade Min</label>
              <InputGroup>
                <Form.Control
                  value={maxHum != null ? maxHum : ''}
                  onChange={(e) => setMaxHum(e.target.value)}
                  placeholder="Umidade  mínima"
                  type="number"
                  className="form-input"
                />
              </InputGroup>
            </Col>

            <Col md={3}>
              <label className="SearchLabel">Umidade Max</label>
              <InputGroup>
                <Form.Control
                  value={minHum != null ? minHum : ''}
                  onChange={(e) => setMinHum(e.target.value)}
                  placeholder="Umidade  máxima"
                  type="number"
                  className="form-input"
                />
              </InputGroup>
            </Col>

            <Col md={3}>
              <label className="SearchLabel">Data/Hora Início  </label>
              <InputGroup>
                <Form.Control
                  value={dateInit}
                  onChange={(e) => setDateInit(e.target.value)}
                  placeholder="Data/Hora Início"
                  type="datetime-local"
                  className="form-input"
                />
              </InputGroup>
            </Col>

            <Col md={3}>
              <label className="SearchLabel">Data/Hora Fim</label>
              <InputGroup>
                <Form.Control
                  value={dateEnd}
                  onChange={(e) => setDateEnd(e.target.value)}
                  placeholder="Data/Hora Fim"
                  type="datetime-local"
                  className="form-input"
                />
              </InputGroup>
            </Col>

            <Col md={3} className="AlignCenter">
              <label>
                <span>Filtrar data em UTC? {utcDate.toString() === 'false' ? 'Não' : 'Sim'}</span><br></br>
                <Switch onChange={(e) => setUtcDate(e)} checked={utcDate} />
              </label>
            </Col>

            <Col md={2}>
              <Button className="CustomButton" onClick={async () => await applyFilters()} variant="default" type="button" >
                Filtrar
              </Button>
            </Col>
          </Row>
        </Form>
      </>
    )
  }

  function exportButtons() {
    return (
      <div className="CustomRow">
        <div className="left">
        </div>

        <div className="right">
          <button onClick={() => downloadExcel()} className="btn customBtn btn-success">
            Exportar para Excel
        </button>
          <button onClick={() => downloadPDF()} className="btn customBtn btn-danger">
            Exportar para PDF
        </button>
        </div>
      </div>
    )
  }



  return (
    <div className="DeviceHistory sidenav-margin">
      <AresNavBar />
      <SideBar />
      <div className="content">
        <div className="container-header">
          <h1>Histórico {location.state.name}</h1>
          <h2>{location.state.model}</h2>
          <h2>{mac}</h2>
        </div>

        {
          key != 'logs' && key != 'notifications' ? showFilters() : ''
        }

        <Tabs
          id="controlled-tab"
          activeKey={key}
          onSelect={(k) => tabController(k)}
          className="Tabs-beacon-devices"
        >
          <Tab eventKey="data" title="Dados">
            <div className="data-table-container CustomContainer">
              {loading ?
                renderLoading()
                : deviceTable()
              }
            </div>
          </Tab>
          <Tab eventKey="graph" title="Gráfico">
            <div className="data-table-container" >
              {loading ?
                renderLoading()
                : renderGraphs()
              }
            </div>
          </Tab>
          <Tab eventKey="logs" title="Eventos">
            <div className="data-table-container" >
              {loading ?
                renderLoading()
                : renderLogs()
              }
            </div>
          </Tab>
          <Tab eventKey="notifications" title="Alarmes">
            <div className="data-table-container" >
              {loading ?
                renderLoading()
                : renderNotifications()
              }
            </div>
          </Tab>
        </Tabs>
      </div>

    </div>
  );

  function renderGraphs() {
    return <>
      <DeviceChart device={device} location={location} deviceData={deviceHistory} modal={false} />
    </>
  }

  function renderLogs() {
    return <>
      <DeviceLog />
    </>
  }

  function renderNotifications() {
    return <>
      <DeviceNotification />
    </>
  }


  function deviceTable() {
    return (<div>
      <div className="beacon-table">
        <DataTableExtensions
          {...tableData}
          filterPlaceholder="Pesquisar histórico"
          print={false}
        >
          <DataTable
            noDataComponent={
              <span>Nada encontrado.</span>
            }
            pagination={true}
            customStyles={customStyles}
          />
        </DataTableExtensions>
      </div>
    </div>);
  }
}

export default DeviceHistory;